function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { withTimeout, PromiseStatus } from "./promise-utils";
import * as Sentry from "@sentry/nextjs";
import { ReachabilityStatus, CONFIG, URL_CHECKS_ENCODED } from "./scripts-reachability-constants";
import { isTesting } from "services/environment-service";
import { BIG_BRAIN_VISITOR_ID } from "/constants/cookies";
import { getCookie } from "/services/cookies-service";
const URL_CHECKS = JSON.parse(atob(URL_CHECKS_ENCODED));
const checkUrlReachable = function() {
    var _ref = _async_to_generator(function*(url, method = "HEAD") {
        if (!window.fetch) {
            return ReachabilityStatus.Error;
        }
        const res = yield withTimeout(fetch(url, {
            method,
            mode: "no-cors"
        }), CONFIG.timeoutMs);
        if (res.status === PromiseStatus.Resolved) {
            return ReachabilityStatus.Allowed;
        }
        if (res.status === PromiseStatus.Timeout) {
            return ReachabilityStatus.Timeout;
        }
        return ReachabilityStatus.Blocked;
    });
    return function checkUrlReachable(url) {
        return _ref.apply(this, arguments);
    };
}();
const runChecks = function() {
    var _ref = _async_to_generator(function*() {
        const urlCheckPromises = URL_CHECKS.map((check)=>checkUrlReachable(check.url, check.method));
        const urlCheckResults = yield Promise.all(urlCheckPromises);
        const result = {};
        URL_CHECKS.forEach((check, index)=>{
            result[check.key] = urlCheckResults[index];
        });
        result.visitor_id = getCookie(BIG_BRAIN_VISITOR_ID) || "";
        return result;
    });
    return function runChecks() {
        return _ref.apply(this, arguments);
    };
}();
export const checkAndReportScriptsReachability = function() {
    var _ref = _async_to_generator(function*() {
        if (isTesting) {
            return;
        }
        try {
            const lastCheck = localStorage.getItem(CONFIG.storageKey);
            const now = Date.now();
            if (lastCheck && now - parseInt(lastCheck, 10) < CONFIG.twoWeeksMs) {
                return;
            }
            const result = yield runChecks();
            yield reportScriptsReachability(result);
            localStorage.setItem(CONFIG.storageKey, Date.now().toString());
        } catch (e) {
            Sentry.captureException(e);
        }
    });
    return function checkAndReportScriptsReachability() {
        return _ref.apply(this, arguments);
    };
}();
export const reportScriptsReachability = function() {
    var _ref = _async_to_generator(function*(result) {
        const url = process.env.SCRIPTS_REACHABILITY_URL;
        const body = window.btoa(JSON.stringify(result));
        try {
            yield fetch(url, {
                method: "POST",
                keepalive: true,
                headers: {
                    "Content-Type": "text/plain"
                },
                body: body
            });
        } catch (error) {
            Sentry.captureException(error);
        }
    });
    return function reportScriptsReachability(result) {
        return _ref.apply(this, arguments);
    };
}();
